module.exports = __webpack_public_path__ + "85d2764498f13edbffd104c464a22b6a.svg";